import {
  convertLegacyPlugin,
  convertLegacyRouteRef,
} from '@backstage/core-compat-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { Icon } from '@iconify/react';
import {
  isServiceEntity,
  isWebsiteEntity,
} from '@ipen-portal/ipen-entity-model';
import { and, or, showMonitoring } from '@ipen-portal/plugin-common';
import { backstagePluginPrometheusPlugin as prometheusPlugin } from '@roadiehq/backstage-plugin-prometheus';

export const PrometheusPlugin: ReturnType<typeof convertLegacyPlugin> =
  convertLegacyPlugin(prometheusPlugin, {
    extensions: [
      EntityContentBlueprint.make({
        name: 'prometheus',
        params: {
          filter: and(showMonitoring, or(isServiceEntity, isWebsiteEntity)),
          icon: <Icon icon="simple-icons:prometheus" />,
          loader: async () =>
            import('@roadiehq/backstage-plugin-prometheus').then(m => (
              <m.EntityPrometheusContent />
            )),
          path: '/prometheus',
          routeRef: convertLegacyRouteRef(prometheusPlugin.routes.root),
          title: 'Prometheus',
        },
      }),
    ],
  });
